<template>
  <div>
    <h4>{{ $t("newHabilitation") }}</h4>
    <div class="box-block">
      <div class="text-muted mb-4">
        {{ $t("addHabilitaionsDesc") }}
      </div>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="addNewHabilitation">
          <div class="row">
            <div class="col-12 col-md-2">
              <div class="form-group">
                <validation-provider
                  name="category"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="category"
                    >{{ $t("category") }}<sup class="text-danger">*</sup></label
                  >
                  <select
                    class="form-control p-0 pl-2"
                    v-model="category"
                    id="country"
                    :placeholder="$t('category')"
                    :class="{ 'is-invalid': errors.length }"
                    @change="setSegments"
                  >
                    <option
                      v-for="item in habilitationsCodes"
                      :value="item"
                      :key="item.code"
                    >
                      {{ item.code }}
                    </option>
                  </select>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-2">
              <div class="form-group">
                <validation-provider
                  name="segment"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="segment"
                    >{{ $t("segment") }}<sup class="text-danger">*</sup></label
                  >
                  <select
                    class="form-control p-0 pl-2"
                    v-model="segment"
                    id="country"
                    :placeholder="$t('segment')"
                    :class="{ 'is-invalid': errors.length }"
                  >
                    <option v-for="item in segments" :value="item" :key="item">
                      {{ item }}
                    </option>
                  </select>
                  <span class="text-danger d-none">
                    <small>{{ errors[0] }}</small>
                  </span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label for="certificateNumber">{{
                  $t("certificateNumber")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="certificateNumber"
                  id="certificateNumber"
                  :placeholder="$t('certificateNumber')"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <div v-if="fileName" class="file-name">
                  <label for=""
                    >{{ $t("file") }}<sup class="text-danger">*</sup></label
                  >
                  <div
                    class="form-control form-upload d-flex align-items-center"
                  >
                    <button
                      type="button"
                      class="close text-danger"
                      aria-label="remove"
                      @click.stop.prevent="removeFile()"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                    <div class="pl-1">
                      {{ fileName }}
                    </div>
                  </div>
                </div>

                <validation-provider
                  v-else
                  v-slot="{ errors }"
                  name="file"
                  rules="required|mimes:image/pdf"
                >
                  <label for=""
                    >{{ $t("file") }}<sup class="text-danger">*</sup></label
                  ><span class="small text-muted">(PDF)</span>
                  <label
                    class="form-control form-upload custom-file-label d-flex align-items-center"
                    for="file"
                    :class="{ 'is-invalid': errors.length }"
                  >
                    <input v-model="file" type="hidden" />
                    <input
                      id="file"
                      ref="file"
                      type="file"
                      class="custom-file-input form-upload"
                      placeholder=""
                      @change="handleFileChange($event)"
                    />
                  </label>
                  <span v-if="errors.length" class="text-danger">
                    <small>{{ errors[0] }}</small>
                  </span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="issuedBy"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="issuedBy"
                    >{{ $t("issuedBy") }}<sup class="text-danger">*</sup></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    v-model="issuedBy"
                    id="issuedBy"
                    :placeholder="$t('issuedBy')"
                  />
                  <span class="text-danger d-none">
                    <small>{{ errors[0] }}</small>
                  </span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="delivered"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="delivered"
                    >{{ $t("delivered")
                    }}<sup class="text-danger">*</sup></label
                  >

                  <date-picker
                    v-model="delivered"
                    :format="$t('dateFormat')"
                    value-type="YYYY-MM-DD"
                    name="date"
                    :placeholder="$t('delivered')"
                    :lang="locale"
                    class="form-control form-control_date"
                    :class="{ 'is-invalid': errors.length }"
                    id="Date de naissance"
                  ></date-picker>
                  <span class="text-danger d-none">
                    <small>{{ errors[0] }}</small>
                  </span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="validUntil"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="email"
                    >{{ $t("validUntil")
                    }}<sup class="text-danger">*</sup></label
                  >
                  <date-picker
                    v-model="validUntil"
                    :format="$t('dateFormat')"
                    value-type="YYYY-MM-DD"
                    name="validUntil"
                    :placeholder="$t('validUntil')"
                    :lang="locale"
                    class="form-control form-control_date"
                    :class="{ 'is-invalid': errors.length }"
                    id="validUntil"
                  ></date-picker>
                  <span v-cloak class="text-danger small d-none">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider
                  name="trainee"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="email"
                    >{{ $t("trainee") }}<sup class="text-danger">*</sup></label
                  >

                  <treeselect :maxHeight="200"
                    v-model="trainee"
                    :multiple="false"
                    :options="trainees"
                    :placeholder="$t('trainee')"
                    :class="{ 'is-invalid': errors.length }"
                    :normalizer="normalizer"
                  />
                  <span v-cloak class="text-danger small">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-3">
            <div></div>
            <div v-if="monitor.visible" :class="monitor.type">
              {{ monitor.message }}
            </div>
            <button type="submit" class="btn btn-primary" :disabled="invalid">
              {{ $t("addButton") }}
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import { mapFields } from "vuex-map-fields";
export default {
  name: "addNewHabilitation",
  components: { Treeselect },
  data() {
    return {
      normalizer(node) {
        return {
          id: node.id,
          label: node.fullname,
        };
      },
      trainees: [],
      segment: null,
      category: null,
      file: null,
      certificateNumber: "",
      delivered: null,
      validUntil: null,
      issuedBy: null,
      fileName: "",
      fileSize: null,
      trainee: null,
      segments: [],
      categories: [],
      locale: "",
      monitor: {
        visible: false,
        message: "",
        type: "text-warning",
      },
    };
  },
  computed: {
    ...mapFields([
      "user",
      "habilitations.habilitationsCodes",
      // "habilitations.trainees",
    ]),
  },
  mounted() {
    this.locale = this.user.local;
    this.getHabilotationsCodes();
    this.getTrainees();
  },
  methods: {
    getTrainees() {
      this.$store.dispatch("habilitations/getTrainees").then(response => {
        this.trainees = response
      })
    },
    setSegments() {
      this.segments = this.category.segments;
    },
    getHabilotationsCodes() {
      this.$store.dispatch("habilitations/getHabilotationsCodes");
    },
    async handleFileChange(event) {
      this.file = event.target.files[0];
      this.fileName = this.$lodash.get(event, "target.files[0].name", "");
      this.fileSize = this.$lodash.get(event, "target.files[0].size", "");
    },
    addNewHabilitation() {
      this.$refs.observer.validate().then((valid) => {
        if (!valid) {
          this.monitor.type = "text-danger";
          this.monitor.message = this.$t("errors.requiredFields");
          this.monitor.visible = true;
          setTimeout(() => {
            this.monitorHide();
          }, 1500);
          return;
        }

        let formData = new FormData();
        formData.append("trainee_id", this.trainee);
        formData.append("client_id", this.user.id);
        formData.append("category", this.category.code);
        formData.append("segment", this.segment);
        formData.append("issued_by", this.issuedBy);
        formData.append("certificate_number", this.certificateNumber);
        formData.append("issue_date", this.delivered);
        formData.append("dlv", this.validUntil);
        formData.append("file", this.file);
        this.$store
          .dispatch("habilitations/addNewHabilitation", formData)
          .then((response) => {
            if (response.status === 201) {
              this.monitor.type = "text-success";
              this.monitor.message = this.$t("team.addedSuccessfully");
              this.monitor.visible = true;
              this.$bus.$emit("update-habilitations-list");
              this.reset();
              setTimeout(() => {
                this.monitorHide();
              }, 1500);
            }
          })
          .catch((error) => {
            if (error.response.status == 422) {
              this.file = null;
              this.monitor.type = "text-danger";
              this.monitor.message = this.$t("errors.fileType");
              this.monitor.visible = true;
              setTimeout(() => {
              this.monitorHide();
            }, 1500);
            }else{
            this.email = null;
            this.monitor.type = "text-danger";
            this.monitor.message = this.$t("errors.serverError");
            this.monitor.visible = true;

            }
              
            setTimeout(() => {
              this.monitorHide();
            }, 1500);
          });
      });
    },
    removeFile() {
      this.file = null;
      this.fileName = null;
      this.fileSize = null;
    },
    reset() {
      this.firstname = null;
      this.lastname = null;
      this.email = null;
      this.segment = null;
      this.category = null;
      this.file = null;
      this.certificateNumber = "";
      this.delivered = null;
      this.validUntil = null;
      this.issuedBy = null;
      this.fileName = null;
      this.fileSize = null;
      this.trainee = null;
      this.segments = [];
      this.categories = [];
      this.$refs.observer.reset();
    },
    monitorHide() {
      this.monitor.type = "";
      this.monitor.message = "";
      this.monitor.visible = false;
    },
  },
};
</script>

<style></style>
